import { isProductionOnly } from './printRoles.js';

export const DASHBOARD_PROFILES = [
  { id: 'auto', label: 'Automático según permisos y funciones' },
  { id: 'management', label: 'Administración · panorama del taller' },
  { id: 'finance', label: 'Finanzas · pagos y control' },
  { id: 'design', label: 'Diseño · asignaciones y plazos' },
  { id: 'production', label: 'Producción · avance y prioridades' },
  { id: 'commercial', label: 'Comercial · cotizaciones y entregas' },
];
export function availableDashboards(user) {
  return DASHBOARD_PROFILES.filter(p => p.id === 'auto' || p.id === 'design' || p.id === 'production'
    || (p.id === 'management' && user.role === 'admin')
    || (p.id === 'finance' && (user.financeAccess === true || user.finance_access === true))
    || (p.id === 'commercial' && !isProductionOnly(user)));
}
export function resolveDashboard(user) {
  const requested = user.dashboardProfile ?? user.dashboard_profile ?? 'auto';
  const roles = user.printRoles ?? user.print_roles ?? [];
  const fallback = (user.financeAccess || user.finance_access) ? 'finance'
    : roles.includes('designer') || user.designAccess || user.design_access ? 'design'
    : user.role === 'admin' ? 'management' : isProductionOnly(user) ? 'production' : 'commercial';
  const profile = requested !== 'auto' && availableDashboards(user).some(p => p.id === requested) ? requested : fallback;
  const requestedScope = user.dashboardScope ?? user.dashboard_scope ?? 'auto';
  const scope = requestedScope === 'mine' || requestedScope === 'team' ? requestedScope : profile === 'design' || (profile === 'commercial' && user.role !== 'admin') ? 'mine' : 'team';
  return { profile, scope };
}
